export const getJwtToken = async (): Promise<string | null> => {
    // Lazy import `store` and `selectJwtToken` inside the function
    const { default: store } = require("../redux/store");
    const { selectJwtToken } = require("../redux/slices/authSlice");

    // Get the current state
    const state = store.getState();
    let token = selectJwtToken(state);

    // If token is not available, wait for auth state to be fetched
    if (!token) {
        // Wait for auth state to be fetched
        await new Promise<void>((resolve) => {
            const unsubscribe = store.subscribe(() => {
                const newState = store.getState();
                const newToken = selectJwtToken(newState);
                if (newToken) {
                    unsubscribe();
                    resolve();
                }
            });
        });

        // Get the token after auth state is fetched
        token = selectJwtToken(store.getState());
    }

    return token;
};
